/**
 * Application version information
 * 
 * This file provides access to the application version from package.json
 * through an environment variable that's injected during the build process.
 * 
 * In development, it will use the version from package.json directly.
 * In production, it will use the version that was embedded during build time.
 */

// The version is injected by Create React App during build
// If not available (in development), we use a default value
const appVersion = process.env.REACT_APP_VERSION || '0.1.0';

export default appVersion;
